import React from 'react';

import GenericConnector from './GenericConnector';

const ConnectorWizardHost = ({
  open,
  caseid,
  connectorType,
  connectorTitle = '',
  onClose,
  onDatasourceConfigured,
  beforeOpen,
  ensureCase,
  projectCreationWizardMode = false,
  aiGenerated = false,
  guideUrl = '',
  pluginOAuth = null,
  pluginMemory = null,
  loadFailed = false,
  loadError = '',
}) => {
  if (!open || !connectorType) {
    return null;
  }

  return (
    <GenericConnector
      key={`${connectorType}:${connectorTitle || connectorType}`}
      caseid={caseid}
      type={connectorType}
      title={connectorTitle || connectorType}
      forceOpen
      hideLauncher
      onConnectorClosed={onClose}
      onDatasourceConfigured={onDatasourceConfigured}
      beforeOpen={beforeOpen}
      ensureCase={ensureCase}
      projectCreationWizardMode={projectCreationWizardMode}
      aiGenerated={aiGenerated}
      guideUrl={guideUrl}
      pluginOAuth={pluginOAuth}
      pluginMemory={pluginMemory}
      loadFailed={loadFailed}
      loadError={loadError}
    />
  );
};

export default ConnectorWizardHost;
